import {
  Armchair, BedDouble, Backpack, Blocks, Car, Dice5, Droplet, Dumbbell, Flame, Footprints,
  Gamepad2, Glasses, Headphones, Lamp, Laptop, Mouse, Package, Scissors, Shirt, Smartphone,
  Sparkles, Speaker, Watch, type LucideIcon,
} from 'lucide-react';

/** Catalog icon keys -> lucide icons. Used for category tiles and product illustrations (until real images exist). */
export const catalogIcons = {
  headphones: Headphones,
  watch: Watch,
  speaker: Speaker,
  mouse: Mouse,
  laptop: Laptop,
  smartphone: Smartphone,
  shirt: Shirt,
  backpack: Backpack,
  glasses: Glasses,
  footprints: Footprints,
  dumbbell: Dumbbell,
  droplet: Droplet,
  lamp: Lamp,
  bed: BedDouble,
  flame: Flame,
  armchair: Armchair,
  sparkles: Sparkles,
  scissors: Scissors,
  blocks: Blocks,
  car: Car,
  dice: Dice5,
  gamepad: Gamepad2,
  package: Package,
} as const satisfies Record<string, LucideIcon>;

export type CatalogIconKey = keyof typeof catalogIcons;

export const getCatalogIcon = (key?: string): LucideIcon =>
  (key && key in catalogIcons ? catalogIcons[key as CatalogIconKey] : Package);
